import FetcherApi from "components/components/FetcherApi";
import urlTools from "components/tools/urlTools";
import webTools from "components/tools/webTools";
import * as constants from "components/constants/constants";

const AuthService = {
    logout: async () => {
        await FetcherApi.post(urlTools.constructRoute("api/account/logout"));
        window.sessionStorage.removeItem(constants.HANDSHAKE_SESSION_STORAGE);
        webTools.reloadToRoute("login");
    },
    
    login: async (credentials, recaptchaToken) => {
        const requestSettings = { recaptchaToken };
        return FetcherApi.post('/api/Account/Login', credentials, requestSettings);
    },
    
    loginAfterTwoFactor: async () => {
        return FetcherApi.post('/api/Account/login-after-two-factor');
    },
    
    sendEmailVerification: async (email) => {
        return FetcherApi.post(
            urlTools.constructRoute(`api/EmailVerification/SendEmailVerificationLink/${email}`)
        );
    },
    
    setEmailB2C: async (email, birthDate) => {
        return FetcherApi.post(
            urlTools.constructRoute("api/PasswordRecovery/SetEmailB2C"),
            { email, birthDate }
        );
    },
    
    setEmailB2B: async (email) => {
        return FetcherApi.post(
            urlTools.constructRoute("api/PasswordRecovery/SetEmailB2B"),
            { email }
        );
    }
};

export default AuthService;